import React from 'react';
import './sidebar.scss';
import { Badge, Box, SpeedDial, SpeedDialIcon } from '@mui/material';
import { secondSidebarInterface } from './SidebarSecondInterfaces';
import CreateIcon from '@mui/icons-material/Create';
import { status } from '../../utils/StatusCalculator';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const SidebarSecond = <T extends Record<string, any>>(props: secondSidebarInterface<T>) => {
    return (
        <div className="sidebar-second second">
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h3 className="second-title">{props.title}</h3>
                {props.addButton ? (
                    <props.addButton.component {...props.addButton.params} languages={props.addButton.languages} />
                ) : props.isAddNew === true ? (
                    <SpeedDial
                        ariaLabel="SpeedDial basic example"
                        onClick={props.createNewItem}
                        sx={{
                            position: 'relative',
                            top: 0,
                            right: 15,
                            alignItems: 'flex-end',
                        }}
                        icon={<SpeedDialIcon sx={{ fontSize: '1.6rem' }} />}
                    ></SpeedDial>
                ) : (
                    ''
                )}
            </Box>
            <div className="sidebar-menu menu">
                <ul className="list">
                    {props.data[0]?.id
                        ? props.data.map((item: any) => (
                              <li
                                  className={`list-item item ${props.actualItemId === item.id ? 'item_active' : null}`}
                                  key={item.id}
                                  onClick={() => {
                                      if (item.id) props.setActualItemId?.(item.id);
                                  }}
                              >
                                  {item.isAnswer ? <Badge key={item.id} color="warning" variant="dot"></Badge> : ''}

                                  <span className="item-title">
                                      {item.title
                                          ? item.title?.[props.actualLanguage]
                                          : item.name
                                          ? item.name?.[props.actualLanguage]
                                          : ''}
                                  </span>
                                  <span className="item-edit">
                                      {props.editButton && item['edit'] !== false ? (
                                          <props.editButton.component
                                              {...props.editButton.params}
                                              languages={props.editButton.languages}
                                              textFields={props.editButton.params.textFields?.map((field) => {
                                                  return {
                                                      ...field,
                                                      defaultValue: item[field.name],
                                                  };
                                              })}
                                              component={{
                                                  ...props.editButton?.params?.component,
                                                  data: item,
                                              }}
                                          />
                                      ) : (
                                          !props.edit || <CreateIcon onClick={() => console.log('edit')} />
                                      )}
                                  </span>
                                  <span className="item-delete">
                                      {props.deleteButton ? (
                                          <props.deleteButton.component
                                              {...props.deleteButton.params}
                                              action={() => {
                                                  if (props.deleteButton) props.deleteButton.params.action(item.id);
                                              }}
                                          />
                                      ) : (
                                          ''
                                      )}
                                  </span>
                                  {props.hideStatus || (
                                      <span
                                          className={`item-status item-status_${status(
                                              item.publishTo,
                                              item.publishFrom,
                                          ).toLowerCase()}`}
                                      >
                                          {status(item.publishTo, item.publishFrom)}
                                      </span>
                                  )}
                              </li>
                          ))
                        : null}
                </ul>
            </div>
        </div>
    );
};

export default SidebarSecond;
